import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';

import {ICreateGatedModalProps} from 'entities/user';

import NotifyChannelIntro from '../NotifyChannel/NotifyChannelIntro';

import WebhookForm from './WebhookForm';
import WebhookPayloadHint from './WebhookPayloadHint/WebhookPayloadHint';

const WebhookModal: React.FC<ICreateGatedModalProps> = ({open, handleClose}) => (
    <MainModal
        header={t`Добавить вебхук`}
        open={open}
        handleClose={handleClose}
        size="md"
    >
        <NotifyChannelIntro
            text={t`Укажите публичный URL и название. На этот адрес будет уходить POST с JSON инцидента
                    при его открытии и разрешении.`}
        >
            <WebhookPayloadHint/>
        </NotifyChannelIntro>
        <WebhookForm onSuccess={handleClose} onClose={handleClose}/>
    </MainModal>
);

export default WebhookModal;
